import { render } from "./InvoiceUploadContent.vue?vue&type=template&id=889de592&scoped=true"
import script from "./InvoiceUploadContent.vue?vue&type=script&lang=js"
export * from "./InvoiceUploadContent.vue?vue&type=script&lang=js"

import "./InvoiceUploadContent.vue?vue&type=style&index=0&id=889de592&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889de592"]])

export default __exports__